import { render } from "./ProfileBody.vue?vue&type=template&id=1040ff48"
import script from "./ProfileBody.vue?vue&type=script&lang=js"
export * from "./ProfileBody.vue?vue&type=script&lang=js"

import "./ProfileBody.vue?vue&type=style&index=0&id=1040ff48&lang=scss"
script.render = render

export default script